import {action, makeObservable, observable} from 'mobx';

import {FileWithMeta} from '_/utilities/types';

import {FileUpload} from './FileUpload';

export class DocumentFileUpload extends FileUpload {
  public readonly casusId: string;
  public readonly casusDisplayNameWithClient?: string;
  public readonly file: FileWithMeta;
  public readonly folderId: string;
  public createdDocumentId?: string;

  public constructor({
    casusId,
    casusDisplayNameWithClient,
    file,
    folderId,
    ...constructorParameters
  }: ConstructorParameters<typeof FileUpload>[0] & {
    casusId: string;
    casusDisplayNameWithClient?: string;
    folderId: string;
    file: FileWithMeta;
  }) {
    super(constructorParameters);
    makeObservable(this, {
      createdDocumentId: observable,
      setCreatedDocumentId: action.bound,
    });
    this.casusId = casusId;
    this.casusDisplayNameWithClient = casusDisplayNameWithClient;
    this.file = file;
    this.folderId = folderId;
  }

  public setCreatedDocumentId(createdDocumentId: string): void {
    this.createdDocumentId = createdDocumentId;
  }
}
